var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',[_c('div',{staticClass:"q-ma-md render-container",domProps:{"innerHTML":_vm._s(_vm.renderedMd)}})])}
var staticRenderFns = []

export { render, staticRenderFns }